import React from 'react'
import PropTypes from 'prop-types'
import merge from 'lodash/merge'
import Standard from './Standard'

class Email extends React.Component {
  static propTypes = {
    validations: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }

  static defaultProps = {
    validations: {},
  }

  render = () => {
    const { validations, ...other } = this.props

    return (
      <Standard
        type='email'
        validations={merge({}, validations, { isEmail: true })}
        {...other}
      />
    )
  }
}

export default Email
